import { 
    QUIZ_PLAYER_CHEATERS_ROUTE,
    DOWNLOAD_QUIZ_EXPORT_ROUTE,
    QUIZ_DELETE_ALL_PLAYERS,
    PSEUDONONYMIZE_PLAYER_ROUTE
} from './constants';
import http from '../../../utils/httpService';
import { baseRoute } from '../../../constants/routes';

/**
 *
 * @param quizID
 * @param from
 * @param to
 * @param resolve
 */
const requestPlayers = (quizID, from, to, resolve) => {
    const data = {
        from: from,
        to: to
    };

    const route = baseRoute + `/statistics/players/${quizID}`;
    return http.request(route, 'POST', data, null, resolve);
};
/**
 *
 * @param id
 * @param quizID
 */
const requestQuizDeleteUserPlayer = (id, quizID) => {
    const data = {
        player_id: id,
        cheatersable_id: quizID,
        cheatersable_type: 'quizLocalization'
    };
    return http.request(QUIZ_PLAYER_CHEATERS_ROUTE, 'POST',  data);
};

const requestPseudononymizePlayer = (id, quizID) => {
    const data = {
        player_id: id,
        quiz_localization_id: quizID
    };
    return http.request(PSEUDONONYMIZE_PLAYER_ROUTE, 'POST',  data);
};
/**
 *
 * @param quizID
 */
const requestQuizExportFile = quizID => {
    const route = DOWNLOAD_QUIZ_EXPORT_ROUTE + `/${quizID}/players`;
    return http.request(route, 'POST');
};
/**
 *
 * @param quizID
 * @param typeData
 * @param withPlayers
 */
const requestQuizDeleteAllUserPlayer = (quizID, typeData, withPlayers) => {
    const route = QUIZ_DELETE_ALL_PLAYERS + `/${quizID}`;
    const data = { data: typeData, withPlayers : withPlayers };
    return http.request(route, 'POST', data);
};

export {
    requestPlayers,
    requestQuizDeleteUserPlayer,
    requestPseudononymizePlayer,
    requestQuizExportFile,
    requestQuizDeleteAllUserPlayer
};